import { InputTitle } from 'components/input/InputTitle';
import { Row, Spacing, TextInput, Typography, neutral } from 'enable-ui';
import { InputColor } from 'enums';

import type { TrainerPasswordFormProps } from '../core/type';

import { ERROR_MESSAGE } from 'constants/message';

export const TrainerPasswordForm: React.FC<TrainerPasswordFormProps> = ({
  handleChange,
  password,
  disabledField,
  styles,
  title,
  confirmPassword,
  hasConfirmPassword = false,
  handleConfirmPassword,
}) => {
  return (
    <Row
      direction="column"
      style={{
        paddingTop: 12,
        marginTop: 48,
        borderTop: `1px solid ${neutral['neutral-5']}`,
        ...styles,
      }}
    >
      <Typography
        weight={500}
        style={{ fontSize: 22, lineHeight: '30px', color: '#222222', marginBottom: 16 }}
      >
        {title || 'Password'}
      </Typography>
      <Spacing
        type="margin"
        style={{
          width: '100%',
          marginBottom: 24,
        }}
      >
        <InputTitle title="Password" />
        <TextInput
          name="password"
          type="password"
          containerStyle={{ maxWidth: 'auto' }}
          value={password}
          onChange={handleChange}
          disabled={disabledField}
        />
      </Spacing>
      {hasConfirmPassword && (
        <Spacing
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputTitle title="Re-enter new password" />
          <TextInput
            name="password"
            type="password"
            containerStyle={{ maxWidth: 'auto' }}
            value={confirmPassword}
            onChange={handleConfirmPassword}
            disabled={disabledField}
            color={
              password && confirmPassword && password !== confirmPassword
                ? InputColor.Error
                : InputColor.Default
            }
            helperText={
              password && confirmPassword && password !== confirmPassword
                ? ERROR_MESSAGE.CONFIRMED_PASSWORD_NOT_MATCHING
                : ''
            }
          />
        </Spacing>
      )}
    </Row>
  );
};
